module.exports = __webpack_public_path__ + "static/media/process-online-01.6b2bfd50.svg";